import { Button, Card, Icon, Pill, Stack, Text } from '@/design-system'
import { BentoGrid, BentoSpan } from '@/components/Bento'
import { PageHeader } from '@/app/layouts/PageHeader'
import checkout from '@/app/layouts/CheckoutLayout.module.css'

const RAILS = [
  { icon: 'account_balance', title: 'Bank transfer', body: 'From any account in your name', fee: 'Free', time: 'Same day', best: true },
  { icon: 'credit_card', title: 'Debit card', body: 'Instant, from a card you already have', fee: '0.5%', time: 'Instant' },
  { icon: 'credit_score', title: 'Credit card', body: 'Instant, but your issuer may treat it as a cash advance', fee: '2.5%', time: 'Instant' },
  { icon: 'currency_bitcoin', title: 'Stablecoin', body: 'USDC on Base or Solana', fee: 'Free', time: 'Minutes' },
]

export function AddMoneyScreen() {
  return (
    <>
      <PageHeader
        title="Add money"
        subtitle="Four ways in. The cheapest one is the default, and we say what each costs before you pick."
      />

      <BentoGrid>
        <BentoSpan span={3}>
          <Card tone="light">
            <Text variant="caption" weight="semibold">
              How do you want to add it?
            </Text>
            <div className={`${checkout.reasons} pb-mt-2`}>
              {RAILS.map((rail) => (
                <button key={rail.title} type="button" className={checkout.reason} style={{ width: '100%', textAlign: 'left' }}>
                  <Icon name={rail.icon} size={22} />
                  <Stack grow gap={1}>
                    <Stack direction="row" align="center" gap={2}>
                      <Text variant="caption" weight="semibold">
                        {rail.title}
                      </Text>
                      {rail.best && <Pill tone="accent">Cheapest</Pill>}
                    </Stack>
                    <Text variant="caption" tone="secondary">
                      {rail.body}
                    </Text>
                  </Stack>
                  <Stack align="end" gap={1}>
                    <Text variant="caption" weight="semibold" numeric>
                      {rail.fee}
                    </Text>
                    <Text variant="eyebrow" tone="secondary">
                      {rail.time}
                    </Text>
                  </Stack>
                </button>
              ))}
            </div>
          </Card>
        </BentoSpan>

        <Card tone="dark">
          <Text variant="caption" weight="semibold" tone="onDark">
            Your US details
          </Text>
          <Stack gap={4} className="pb-mt-4">
            {[
              ['Account holder', 'Alex Turner'],
              ['Routing number', '084106768'],
              ['Account number', '9600 0012 4568'],
              ['Account type', 'Checking'],
            ].map(([label, value]) => (
              <Stack key={label} gap={1}>
                <Text variant="eyebrow" tone="onDarkMuted">
                  {label}
                </Text>
                <Text variant="caption" weight="semibold" tone="onDark" numeric>
                  {value}
                </Text>
              </Stack>
            ))}
          </Stack>
          <Card.Footer>
            <Button variant="onDark" size="md" block iconStart="content_copy">
              Copy details
            </Button>
            <Button size="md" block iconEnd="arrow_forward" to="/add-money/done" className="pb-mt-3">
              I have sent it
            </Button>
          </Card.Footer>
        </Card>
      </BentoGrid>
    </>
  )
}
